
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EarlyAccessModal from "../hero/EarlyAccessModal";

interface NavbarActionsProps {
  closeMenu?: () => void;
  isMobile?: boolean;
}

const NavbarActions: React.FC<NavbarActionsProps> = ({ closeMenu, isMobile = false }) => {
  const { t } = useTranslation();
  const [showEarlyAccessModal, setShowEarlyAccessModal] = useState(false);

  const handleEarlyAccessClick = () => {
    setShowEarlyAccessModal(true);
    if (closeMenu) {
      closeMenu();
    }
  };

  if (isMobile) {
    return (
      <>
        <div className="border-t border-white/10 p-6 space-y-4 bg-propmatch-dark/95 backdrop-blur-md">
          <Link 
            to="/contact" 
            onClick={closeMenu}
            className="block"
          >
            <span className="block text-white/90 hover:text-white transition-colors duration-200 py-2 px-4 border border-white/20 rounded-lg text-center">
              {t("nav.contact")}
            </span>
          </Link>
          <button 
            onClick={handleEarlyAccessClick}
            className="block w-full"
          >
            <span className="block bg-gradient-to-r from-propmatch-blue to-propmatch-blue-light py-3 rounded-lg text-white font-medium text-center shadow-lg shadow-propmatch-blue/20">
              Register
            </span>
          </button>
        </div>
        <EarlyAccessModal 
          isOpen={showEarlyAccessModal} 
          onClose={() => setShowEarlyAccessModal(false)} 
        />
      </>
    );
  }

  return (
    <>
      <div className="hidden md:flex items-center space-x-2 lg:space-x-3">
        <Link to="/contact" className="flex items-center">
          <span className="btn-outline px-3 py-1.5 md:px-4 md:py-2 text-xs md:text-sm hover:border-propmatch-blue-light whitespace-nowrap flex items-center h-full">
            <span>{t("nav.contact")}</span>
          </span>
        </Link>
        <button onClick={handleEarlyAccessClick} className="flex items-center">
          <span className="btn-primary px-3 py-1.5 md:px-4 md:py-2 text-xs md:text-sm whitespace-nowrap flex items-center h-full">
            <span>Register</span>
          </span>
        </button>
      </div>
      <EarlyAccessModal 
        isOpen={showEarlyAccessModal} 
        onClose={() => setShowEarlyAccessModal(false)} 
      />
    </>
  );
};

export default NavbarActions;
